<footer class="test-environment-footer" style="z-index: 1;">
<p class="repeated-text">AMBIENTE DIMOSTRATIVO</p>
</footer>